import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import './Auth.css';

const Register = () => {
  const { t } = useTranslation();
  
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    market_name: '',
    preferred_language: 'en',
  });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await register(formData);
      toast.success(t('registerSuccess'));
      navigate('/login');
    } catch (error) {
      const errorMsg = error.response?.data?.username?.[0] || 
                       error.response?.data?.error || 
                       t('error');
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="auth-title">{t('register')}</h1>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label>{t('marketName')}</label>
            <input
              type="text"
              name="market_name"
              value={formData.market_name}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

          <div className="form-group">
            <label>{t('username')}</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

          <div className="form-group">
            <label>{t('password')}</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="form-control"
              required
              minLength={8}
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? '...' : t('signUp')}
          </button>
        </form>

        <div className="auth-footer">
          {t('alreadyHaveAccount')} <Link to="/login">{t('signIn')}</Link>
        </div>
      </div>
    </div>
  );
};

export default Register;
